<template>
  <div id="load_wrap" :style="{ position: isInApp && showTabbar ? 'relative' : 'fixed' }">
    <div class="load" @click.stop="closeLoading">
      <div class="close-btn">
        <van-icon name="cross" />
      </div>
      <lottie :options="options" class="lottie" />
      <p>等待登录结果中</p>
    </div>
  </div>
</template>

<script>
  import Lottie from '@components/Lottie'
  import globalLoading from '@animation/globalLoading'
  import {
    mapGetters
  } from '@utils/vuex'

  export default {
    components: {
      Lottie
    },
    data() {
      return {
        options: {
          loop: true,
          animationData: globalLoading
        },
        timer: null,
        showCloseBtn: false
      }
    },
    computed: {
      ...mapGetters(['isInApp']),
      showTabbar() {
        return this.$store.state.common.showTabbar
      }
    },
    mounted() {
      this.timer = setTimeout(() => {
        this.$store.commit('setHideAppLoginLoading')
        sessionStorage.removeItem('isAPPLogin')
      }, 10000)
    },
    beforeDestroy() {
      if (this.timer) clearTimeout(this.timer)
    },
    methods: {
      closeLoading() {
        if (this.timer) clearTimeout(this.timer)
        this.$store.commit('setHideAppLoginLoading')
        sessionStorage.removeItem('isAPPLogin')
      }
    }
  }
</script>

<style lang="scss" scoped>
  #load_wrap {
    width: 100%;
    height: 100%;
    position: fixed;
    background: #fff;
    left: 0;
    top: 0;
    z-index: 10000001;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .close-btn {
    position: relative;
    top: -4rem;
    right: -4rem;
    font-size: 1.2rem;
    color: #2196f3;
  }

  .load {
    width: 116px;
    height: 66px;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .lottie {
    width: 1.4rem;
  }

  .load p {
    text-align: center;
    color: #2196f3;
  }
</style>